<form novalidate
      [formGroup]="form"
      (keyup.enter)="submit()"
>
  <div class="p-field mx-w-420">
    <div class="p-field__title">
      <label class="text--md" for="input-old-password">Old password</label>
      <app-icon-feather *ngIf="oldPassword.valid" icon="check-circle"></app-icon-feather>
      <app-icon-feather *ngIf="oldPassword.dirty && oldPassword.invalid" icon="x-circle"></app-icon-feather>
    </div>
    <input id="input-old-password"
           type="password"
           pInputText
           placeholder="***************"
           autocomplete="off"
           name="oldPassword"
           [formControl]="oldPassword"
    >
    <div class="position-relative">
      <small class="p-error"
             *ngIf="oldPassword.dirty && oldPassword.invalid"
      >
        {{ getErrorMessage('Old password', oldPassword) }}
      </small>
    </div>
  </div>

  <div class="p-field mx-w-420">
    <div class="p-field__title">
      <label class="text--md">Create new password</label>
      <app-icon-feather *ngIf="newPassword.valid" icon="check-circle"></app-icon-feather>
      <app-icon-feather *ngIf="newPassword.dirty && newPassword.invalid" icon="x-circle"></app-icon-feather>
    </div>
    <app-password-complexity-check [control]="newPassword"></app-password-complexity-check>
    <div class="position-relative">
      <small class="p-error"
             *ngIf="newPassword.dirty && newPassword.invalid"
      >
        {{ getErrorMessage('New password', newPassword) }}
      </small>
    </div>
  </div>

  <div class="p-field mx-w-420">
    <div class="p-field__title">
      <label class="text--md" for="input-new-password-repeat">Confirm new password</label>
      <app-icon-feather *ngIf="newPasswordRepeat.valid" icon="check-circle"></app-icon-feather>
      <app-icon-feather *ngIf="newPasswordRepeat.dirty && newPasswordRepeat.invalid" icon="x-circle"></app-icon-feather>
    </div>
    <input id="input-new-password-repeat"
           type="password"
           pInputText
           placeholder="***************"
           autocomplete="off"
           name="newPassword"
           [formControl]="newPasswordRepeat"
    >
    <div class="position-relative">
      <small class="p-error"
             *ngIf="newPasswordRepeat.dirty && newPasswordRepeat.invalid"
      >
        {{ getErrorMessage('Password confirm', newPasswordRepeat) }}
      </small>
    </div>
  </div>

  <div class="mt-5">
    <button pButton
            type="submit"
            label="SAVE"
            [disabled]="form.invalid"
            (click)="submit()"
    ></button>
  </div>
</form>
